// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zvmixzvxrkjyoussyuuq.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp2bWl4enZ4cmtqeW91c3N5dXVxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY3MTQ2ODEsImV4cCI6MjA2MjI5MDY4MX0.i2KWdzVLx_zFqteiX7SVy-TdnaoEhM--Je4_9ocX9fs";

// Supabase istemcisini oluşturuyoruz
export const supabase = createClient<Database>(
  SUPABASE_URL, 
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
    },
    global: {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Prefer': 'return=representation'
      },
    },
  }
);

// Yardımcı fonksiyon: Doğrudan SQL çalıştırmak için
export const executeSql = async (sql: string) => {
  try {
    // Doğrudan SQL çalıştırmak için bir yöntem kullanmalıyız
    // Supabase client'ta bu yeteneği direkt olarak kullanamıyoruz,
    // bu yüzden RPC fonksiyonları kullanmalıyız ya da
    // dinamik olarak bir geçici supabase istemcisi oluşturmalıyız.
    
    // Basitleştirilmiş istemci
    const client = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
    
    // RPC ile SQL çalıştırma girişimi - NOT: Bu çalışmayabilir
    // çünkü RPC fonksiyonu sunucuda tanımlı olmalıdır
    const { data, error } = await (client as any).rpc('execute_sql', { sql });
    
    if (error) {
      console.error('SQL çalıştırma hatası:', error);
      throw error;
    }
    
    return data;
  } catch (error) {
    console.error('SQL çalıştırma başarısız:', error);
    throw error;
  }
};

// NOT: Hata alıyorsanız, tarayıcınızda localStorage'a erişim 
// izinlerinin açık olduğundan ve çerezlerin engellenme durumunda 
// olmadığından emin olun. 401 hatası, kimlik doğrulama
// problemlerini işaret eder.

/* 
SUPABASE RLS POLİTİKALARI İÇİN ÇÖZÜM:

1. Supabase dashboard'a gidin: https://supabase.com/dashboard/project/zvmixzvxrkjyoussyuuq
2. Table Editor bölümüne gidin ve "page_contents" tablosunu seçin
3. "Authentication" sekmesine gidin
4. "Row Level Security (RLS)" ayarlarını görüntüleyin
5. RLS ayarlarını aşağıdaki gibi güncelleyin:

   a) Eğer RLS etkinse ve sorun yaşıyorsanız, şu policy'yi ekleyin:
      - Policy name: "Allow authenticated users full access"
      - Policy definition: (auth.role() = 'authenticated')
      - Policy actions: ALL
   
   b) Veya geliştirme aşamasında iseniz, RLS'i geçici olarak devre dışı 
      bırakabilirsiniz (NOT: Üretim ortamında güvenli değildir)

Not: Supabase RLS politikaları tabloların güvenliğini kontrol eder ve bir 401 hatası
genellikle RLS politikasını geçemediğiniz anlamına gelir.
*/
